module.exports = __webpack_public_path__ + "media/private_message-0c8a7b80bba139eb982a4ff2d7d6f532.mp3";